
const parseDataToCrm = (data: Array<any>, contactData: any) => {
  let results: any = {};

  let answers: string = "";
  for (const dataItem of data) {
    const {title, alternative_text} = dataItem;
    // Check if alternative_text is an array or a string
    if (Array.isArray(alternative_text)) {
      answers += `${title.trim()}: ${alternative_text.join('; ')}\n`;
    } else {
      answers += `${title.trim()}: ${alternative_text}\n`;
    }
  }

  results = {
    nombre: `${contactData.name} - Adviser`,
    email: contactData.email,
    telefono: contactData.phone,
    descripcion: answers,
    utm_source: "Adviser",
    crecepro_asunto: "Formulario - Adviser"
  };

  if (contactData.identification) {
    results["rut"] = contactData.identification;
  }

  return results;
};

export { parseDataToCrm };